<div class="page-shell">
  <div class="page-shell__header">
    <div class="page-shell__header__left">
      <button
        *ngIf="goBack"
        class="page-shell__header__back-btn"
        (click)="goBack()"
        data-testid="back-btn"
      >
        <span class="page-shell__header__back-btn__icon material-icons">chevron_left</span>
      </button>
    </div>
    <div class="page-shell__header__title">
      <ng-content select="[shell-header]"></ng-content>
    </div>
    <div class="page-shell__header__right">
      <ng-content select="[shell-header-action]"></ng-content>
      <frodo-connection-indicator
        *ngIf="showConnectionIndicator"
        class="page-shell__header__connection"
        data-testid="connection-indicator"
      ></frodo-connection-indicator>
    </div>
  </div>
  <main class="page-shell__content">
    <ng-content></ng-content>
  </main>
  <footer class="page-shell__footer">
    <frodo-logo [src]="logoSrc$ | async" alt="apex logo" data-testid="logo"></frodo-logo>
  </footer>
</div>
